import Icon from '../components/Icon.vue'

Icon.register({
  tools: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M501.1 395.7c14.5 14.5 14.5 38.1 0 52.7l-52.7 52.7c-14.5 14.6-38.1 14.6-52.7 0l-117.1-117.1c-23.1-23.1-27.5-57.6-13.9-85.4l-106.6-106.6h-62.1l-96-128 64-64 128 96v62.1l106.6 106.6c27.8-13.7 62.3-9.2 85.4 13.9zM331.7 225c-8.2 0-16.6 1-24.7 2.9l-82.1-82.1c-0.7-37.5 12.7-75.1 41.2-103.6 37-37 89.2-49.6 136.6-37.9 9.1 2.3 12.3 13.6 5.7 20.2l-74.4 74.4 11.3 67.9 67.9 11.3 74.4-74.4c6.6-6.6 17.9-3.5 20.1 5.5 11.8 47.4-0.8 99.6-37.9 136.7-13 13-28 22.6-43.8 29.5l-19.4-19.4c-20-20-46.6-31-74.9-31zM227.8 307c-4.9 21.1-2.6 42.8 5 62.7l-123.6 123.6c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5l152.4-152.5zM64 472c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 13.2 10.8 24 24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tools.js
// module id = 2018
// module chunks = 0